/* Erreichbarkeits-Service: BSP-Bytes rein, Ergebnis und Befunde raus (JSON-tauglich). Genutzt von `xf reach` und vom Prüf-Dialog (geladene BSP). Ohne DOM und Dateien. */
import { analyzeReach, reachItems } from '../analysis/reach.ts';
import type { ReachItem, ReachResult } from '../analysis/reach.ts';
import { toBuffer } from './check.ts';
import type { Bytes } from './check.ts';

export interface ReachReport extends ReachResult { items: ReachItem[]; worst: 'ok' | 'info' | 'warn' | 'err' }
export function reachBsp(bytes: Bytes): ReachReport {
  const r = analyzeReach(toBuffer(bytes)), items = reachItems(r);
  const rank = { ok: 0, info: 1, warn: 2, err: 3 } as const;
  return { ...r, items, worst: items.reduce<ReachReport['worst']>((w, i) => (rank[i.level] > rank[w] ? i.level : w), 'ok') };
}
